import { Convert } from 'core/utils';
import { ClipartDTO } from 'core/api';

import {
	GetMapClipartsRequest,
	GetMapClipartsResponse,
} from 'core/api';

import { Bus } from 'core/infrastructure';
import { ImageElement } from './Map';

export interface MapImageCache {
	getImage(name: string): ImageElement;
	getFloors(): ImageElement[];
	getTables(): ImageElement[];
	getFurnitures(): ImageElement[];
	getCustom(base64Image: string): Promise<ImageElement>;
}

enum ClipartType {
	Floor,
	Table,
	Furniture
}

const process = Bus.buildProcessFn('/bus/');

async function getCliparts(mode: 'IGNORE_STATUS_CLIPARTS' | 'INCLUDE_STATUS_CLIPARTS') {
	const request = new GetMapClipartsRequest({ includeStatusCliparts: mode === 'INCLUDE_STATUS_CLIPARTS' });
	return process(request, (response: GetMapClipartsResponse) => response.Cliparts);
}

export namespace MapImageCache {

	export async function load(mode: 'IGNORE_STATUS_CLIPARTS' | 'INCLUDE_STATUS_CLIPARTS' = 'INCLUDE_STATUS_CLIPARTS'): Promise<MapImageCache> {

		const floors: ImageElement[] = [];
		const tables: ImageElement[] = [];
		const furnitures: ImageElement[] = [];
		const custom: Map<string, ImageElement> = new Map<string, ImageElement>();

		const cache: any = {};

		cache.getImage = function (name: string) {
			return cache[name];
		};
		cache.getFloors = function () {
			return floors;
		};
		cache.getTables = function () {
			return tables;
		};
		cache.getFurnitures = function () {
			return furnitures;
		};

		cache.getCustom = async function (base64Image: string): Promise<ImageElement> {
			if (!custom.has(base64Image)) {
				const blob = Convert.base64StringToBlob(base64Image);
				const result = await Convert.blobToHTMLImage(blob);

				// Es importante dejar el name como el valor base64 de la imagen, porque luego
				// se usará también al volver a serializar el plano a xml
				custom.set(base64Image, { name: base64Image, value: result.img });
			}
			return custom.get(base64Image)!;
		};

		const fillCache = async (clipart: ClipartDTO, type: ClipartType) => {

			const blob = Convert.base64StringToBlob(clipart.Image);
			const result = await Convert.blobToHTMLImage(blob);

			cache[clipart.Name] = { name: clipart.Name, value: result.img };

			switch (type) {
				case ClipartType.Floor:
					floors.push(cache[clipart.Name]);
					break;
				case ClipartType.Table:
					tables.push(cache[clipart.Name]);
					break;
				case ClipartType.Furniture:
					furnitures.push(cache[clipart.Name]);
					break;
			}
		};

		const cliparts = await getCliparts(mode);

		await Promise.all(cliparts.Floors.map(x => fillCache(x, ClipartType.Floor))
			.concat(cliparts.Furnitures.map(x => fillCache(x, ClipartType.Furniture)))
			.concat(cliparts.Tables.map(x => fillCache(x, ClipartType.Table))));

		return cache;
	}
}
